import { costTokens } from "./picker";
/** Footer details from a player's evolution data; undefined off a chain. */
export const evolutionFooterFrom = (evolutionData) => evolutionData?.evolutionPath?.length
    ? {
        chain: evolutionData.evolutionPath.length,
        coins: evolutionData.cost?.coins ?? 0,
        tokens: costTokens(evolutionData.cost),
        games: evolutionData.requiredGames,
    }
    : undefined;
/** Meta rating a chain adds over the base card; never negative. */
export const metaRatingGain = (player, basePlayer) => basePlayer
    ? Math.max(0, player.metaRating - basePlayer.metaRating)
    : undefined;
/** The players list's sorts (`/players`), as both apps offer them. */
export const PLAYERS_SORT_OPTIONS = [
    { labelKey: "toolbar.sort.metaRating", value: "meta-rating" },
    { labelKey: "toolbar.sort.metaRating3Chem", value: "meta-rating-3-chem" },
    { labelKey: "toolbar.sort.rating", value: "rating" },
    { labelKey: "toolbar.sort.new", value: "date-added" },
];
/** The evolution builder's player picker: those, and evo popularity. */
export const EVOS_BUILDER_SORT_OPTIONS = [
    ...PLAYERS_SORT_OPTIONS,
    { labelKey: "toolbar.sort.popularity", value: "evo-popularity" },
];
/** The Players page itself; the pickers don't offer trending. */
export const PLAYERS_PAGE_SORT_OPTIONS = [
    ...PLAYERS_SORT_OPTIONS,
    { labelKey: "toolbar.sort.trending", value: "trending" },
];
/** The evolution players list (`/players/evolutions`). */
export const EVOLUTION_PLAYERS_SORT_OPTIONS = [
    { labelKey: "toolbar.sort.metaRating", value: "meta-rating" },
    { labelKey: "toolbar.sort.upgrade", value: "upgrade" },
    { labelKey: "toolbar.sort.metaRating3Chem", value: "meta-rating-3-chem" },
    { labelKey: "toolbar.sort.upgrade3Chem", value: "upgrade-3-chem" },
    { labelKey: "toolbar.sort.rating", value: "rating" },
];
/** My Evolutions' evolved players: `/evolved-players` has no upgrade sorts. */
export const MY_EVOLVED_PLAYERS_SORT_OPTIONS = [
    { labelKey: "toolbar.sort.metaRating", value: "meta-rating" },
    { labelKey: "toolbar.sort.metaRating3Chem", value: "meta-rating-3-chem" },
    { labelKey: "toolbar.sort.rating", value: "rating" },
];
/** Saved builds. Date added is ordered client-side; 3-chem by the backend. */
export const SAVED_EVOLUTIONS_SORT_OPTIONS = [
    { labelKey: "toolbar.sort.dateAdded", value: "date-added" },
    { labelKey: "toolbar.sort.metaRating", value: "meta-rating" },
    { labelKey: "toolbar.sort.metaRating3Chem", value: "meta-rating-3-chem" },
];
/** The one saved sort the backend has to apply; the rest arrive meta-sorted. */
export const savedEvolutionsServerSort = (sort) => sort === "meta-rating-3-chem" ? sort : undefined;
export const sortSavedEvolutionPlayers = (saved, sort) => sort === "date-added"
    ? [...saved].sort((a, b) => b.createdAt - a.createdAt)
    : saved;
export const sortLabelKey = (options, value) => options.find((option) => option.value === value)?.labelKey;
//# sourceMappingURL=myEvolutions.js.map